"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.loadNews = loadNews;
exports.loadNewsSinglePost = loadNewsSinglePost;
exports.searchArticles = searchArticles;
exports.getLogos = getLogos;

var _underscore = require("underscore");

var _underscore2 = _interopRequireDefault(_underscore);

var _moment = require("moment");

var _moment2 = _interopRequireDefault(_moment);

var _config = require("config");

var _config2 = _interopRequireDefault(_config);

var _striptags = require("striptags");

var _striptags2 = _interopRequireDefault(_striptags);

var _htmlEntities = require("html-entities");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NEWS_INIT = "ms/news/news_init";
var NEWS_LOAD = "ms/news/news_load";
var NEWS_LOAD_SUCCESS = "ms/news/news_load_success";
var NEWS_LOAD_FAIL = "ms/news/news_load_fail";

var SEARCH_LOAD = "ms/news/search_load_fail";
var SEARCH_LOAD_SUCCESS = "ms/news/search_load_success";
var SEARCH_LOAD_FAIL = "ms/news/search_load_fail";

var LOGO_LOAD = "ms/news/logo_load_fail";
var LOGO_LOAD_SUCCESS = "ms/news/logo_load_success";
var LOGO_LOAD_FAIL = "ms/news/logo_load_fail";

var ARTICLES_LOAD = "ms/news/articles_load_fail";
var ARTICLES_LOAD_SUCCESS = "ms/news/articles_load_success";
var ARTICLES_LOAD_FAIL = "ms/news/articles_load_fail";

var initialState = {
  articles: [],
  blog: [],
  search: [],
  loading: false,
  loaded: false,
  error: null,
  page: null,
  articleSlug: null,
  blogUrl: _config2.default.blogUrl,
  searchWord: "",
  megascans_footer_logos: [],
  megascans_wall_logos: []
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case NEWS_INIT:
      return initialState;

    case SEARCH_LOAD:
      return (0, _extends3.default)({}, state, {
        blog: action.blog,
        searchWord: action.searchWord,
        loading: true,
        loaded: false,
        error: null
      });

    case SEARCH_LOAD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        search: action.result,
        blog: action.blog,
        searchWord: action.searchWord,
        loading: false,
        loaded: true,
        error: null
      });
    case SEARCH_LOAD_FAIL:
      return (0, _extends3.default)({}, state, {
        blog: action.blog,
        searchWord: action.searchWord,
        loading: false,
        loaded: true,
        error: action.error
      });
    case LOGO_LOAD:
      return (0, _extends3.default)({}, state, {
        logos: [],
        logoLoaded: false,
        error: null
      });

    case LOGO_LOAD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        megascans_footer_logos: action.result[0].value,
        megascans_wall_logos: action.result[1].value,
        logoLoaded: true,
        error: null
      });
    case LOGO_LOAD_FAIL:
      return (0, _extends3.default)({}, state, {
        megascans_footer_logos: [],
        megascans_wall_logos: [],
        logoLoaded: true,
        error: action.error
      });
    case NEWS_LOAD:
      return (0, _extends3.default)({}, state, {
        loading: true,
        page: action.page,
        articleSlug: action.articleSlug,
        loaded: false,
        error: null
      });

    case NEWS_LOAD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        blog: action.result,
        page: action.page,
        loading: false,
        loaded: true,
        error: null
      });

    case NEWS_LOAD_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        page: action.page,
        loaded: true,
        error: action.error
      });

    case ARTICLES_LOAD:
      return (0, _extends3.default)({}, state, {
        loading: true,
        page: action.page,
        articleSlug: action.articleSlug,
        loaded: false,
        error: null
      });

    case ARTICLES_LOAD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        articles: action.result,
        articleSlug: action.articleSlug,
        loading: false,
        loaded: true,
        page: action.page,
        error: null
      });

    case ARTICLES_LOAD_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        page: action.page,
        articleSlug: action.articleSlug,
        loaded: true,
        error: action.error
      });

    default:
      return state;
  }
}

function getStringWithLimit(str, limit) {
  var count = 0;
  var finalString = "";
  var flag = false;
  str.split(" ").map(function (word) {
    count += word.length;
    if (count < limit) {
      finalString += word + " ";
    } else {
      flag = true;
    }
  });
  if (flag) {
    finalString = finalString + "...";
  }
  return finalString;
}
// Action creators
function loadNews(page, limit) {
  return function (dispatch, getState) {
    if (getState().news.loaded == true && page == getState().news.page && limit <= getState().news.blog.length) return;
    return dispatch({
      types: [NEWS_LOAD, NEWS_LOAD_SUCCESS, NEWS_LOAD_FAIL],
      page: page,
      promise: loadNewsData(page, limit)
    });
  };
}
function strip(html) {
  var doc = new DOMParser().parseFromString(html, "text/html");
  return doc.body.textContent || "";
}
// Private
function loadNewsData(page, limit) {
  var query = "news://wp-json/wp/v2/posts?_embed&page=" + page + "&per_page=" + limit;
  return function (client) {
    var loadingPromise = client.get(query).then(function (result) {
      return result.map(function (a) {
        var entities = new _htmlEntities.XmlEntities();
        var featured_media = a._embedded["wp:featuredmedia"]["0"].source_url;
        var sizes = a._embedded["wp:featuredmedia"]["0"].media_details.sizes;
        var srcUrl = "";
        if (sizes["the_grid_size3"]) {
          srcUrl = sizes["the_grid_size3"].source_url;
        } else if (sizes["large"]) {
          srcUrl = sizes["large"].source_url;
        } else if (sizes["full"]) {
          srcUrl = sizes["full"].source_url;
        }
        var featured_thumbnail = srcUrl;
        return {
          title: entities.decode((0, _striptags2.default)(a.title.rendered)),
          truncatedTitle: getStringWithLimit(entities.decode((0, _striptags2.default)(a.title.rendered)), 50),
          image: featured_media, //featured_media && featured_media.media_details && featured_media.media_details.sizes && featured_media.media_details.sizes.full && featured_media.media_details.sizes.full.source_url,
          thumbnail: featured_thumbnail,
          date: a.date,
          to: a.link,
          id: a.id,
          desc: getStringWithLimit(entities.decode(strip(a.content.rendered)), 84),
          slug: a.slug
        };
      });
    });

    return loadingPromise;
  };
}

function loadNewsSinglePost(slug) {
  return function (dispatch, getState) {
    if (getState().news.loaded == true && slug == getState().news.articleSlug) return;

    return dispatch({
      types: [ARTICLES_LOAD, ARTICLES_LOAD_SUCCESS, ARTICLES_LOAD_FAIL],
      isArticle: true,
      articleSlug: slug,
      page: getState().news.page,
      promise: loadNewsSinglePostData(slug)
    });
  };
}

// Private
function loadNewsSinglePostData(slug) {
  var query = "news://wp-json/wp/v2/posts?_embed&slug=" + slug;
  return function (client) {
    var loadingPromise = client.get(query).then(function (result) {
      var author = result[0]._embedded.author["0"];
      var featured_media = result[0]._embedded["wp:featuredmedia"]["0"].source_url;
      return client.get("news://wp-json/v2/next_prev_posts?id=" + result[0].id).then(function (posts) {
        return result.map(function (a) {
          var entities = new _htmlEntities.XmlEntities();
          return {
            title: entities.decode((0, _striptags2.default)(a.title.rendered)),
            image: featured_media,
            date: a.date,
            to: a.link,
            id: a.id,
            content: a.content.rendered,
            authorName: author.name,
            authorImage: typeof author.avatar_urls["96"] == "undefined" ? null : author.avatar_urls["96"],
            prev: posts.prev == "" ? "" : {
              title: entities.decode((0, _striptags2.default)(posts.prev.post_title)),
              image: posts.prev.image,
              date: posts.prev.post_date,
              id: posts.prev.ID,
              slug: posts.prev.post_name
            },
            next: posts.next == "" ? "" : {
              title: entities.decode((0, _striptags2.default)(posts.next.post_title)),
              image: posts.next.image,
              date: posts.next.post_date,
              id: posts.next.ID,
              slug: posts.next.post_name
            }
          };
        });
      });
    });

    return loadingPromise;
  };
}

function searchArticles(searchWord) {
  return function (dispatch, getState) {
    if (getState().news.loaded == true && searchWord == getState().news.searchWord) return;
    return dispatch({
      types: [SEARCH_LOAD, SEARCH_LOAD_SUCCESS, SEARCH_LOAD_FAIL],
      searchWord: searchWord,
      blog: getState().news.blog,
      promise: searchArticlesPostData(searchWord)
    });
  };
}

function getLogos() {
  return function (dispatch, getState) {
    if (getState().news.megascans_footer_logos.length > 0) {
      return;
    }
    return dispatch({
      types: [LOGO_LOAD, LOGO_LOAD_SUCCESS, LOGO_LOAD_FAIL],
      promise: function promise(client) {
        return client.post("/v1/staticContent/getStaticContent");
      }
    });
  };
}

// Private
function searchArticlesPostData(searchWord) {
  var query = "news://wp-json/wp/v2/posts?_embed&search=" + searchWord + "&page=1&per_page=9";
  return function (client) {
    var loadingPromise = client.get(query).then(function (result) {
      return result.map(function (a) {
        var entities = new _htmlEntities.XmlEntities();
        var featured_media = a._embedded["wp:featuredmedia"]["0"].source_url;
        var sizes = a._embedded["wp:featuredmedia"]["0"].media_details.sizes;

        var srcUrl = "";
        if (sizes["the_grid_size3"]) {
          srcUrl = sizes["the_grid_size3"].source_url;
        } else if (sizes["large"]) {
          srcUrl = sizes["large"].source_url;
        } else if (sizes["full"]) {
          srcUrl = sizes["full"].source_url;
        }
        var featured_thumbnail = srcUrl || featured_media;
        return {
          title: entities.decode((0, _striptags2.default)(a.title.rendered)),
          truncatedTitle: getStringWithLimit(entities.decode((0, _striptags2.default)(a.title.rendered)), 50),
          desc: getStringWithLimit(entities.decode(strip(a.content.rendered)), 84),
          image: featured_media, //featured_media && featured_media.media_details && featured_media.media_details.sizes && featured_media.media_details.sizes.full && featured_media.media_details.sizes.full.source_url,
          thumbnail: featured_thumbnail,
          date: a.date,
          to: a.link,
          id: a.id,
          slug: a.slug
        };
      });
    });

    return loadingPromise;
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/news.js
// module id = 189
// module chunks = 0